import { Component, EventEmitter, Inject, InjectionToken, Input, OnDestroy, OnInit, Optional, Output } from '@angular/core';
import { Subject } from 'rxjs';
import { startWith, switchMap, takeUntil, tap } from 'rxjs/operators';
import { UiRouterState } from '../../../services/ajs-router-state.service';
import { ProfileIntegrationService } from '../../../services/profile/profile-integration.service';

export const ONE_MINUTE_IN_MILLIS = 60 * 1000;
export const REFRESH_TIMEOUT = new InjectionToken<number>('REFRESH_TIMEOUT');

@Component({
  selector: 'mandae-integration-settings-step',
  templateUrl: './integration-settings.component.html',
  styleUrls: ['./integration-settings.component.scss']
})
export class IntegrationSettingsComponent implements OnInit, OnDestroy {

  @Input() number = 1;

  @Input() warning = '';
  @Output() warningChange = new EventEmitter<string>();

  @Input()
  public get complete(): boolean {
    return this._complete;
  }
  public set complete(value: boolean) {
    if (this._complete !== value) {
      this._complete = value;
      this.completeChange.emit(value);
    }
  }
  private _complete = false;
  @Output() completeChange = new EventEmitter<boolean>();

  private destroyed = new Subject();

  constructor(
    private router: UiRouterState,
    private profileIntegrationService: ProfileIntegrationService,
    @Optional() @Inject(REFRESH_TIMEOUT) private readonly refreshTimeout: number,
  ) {
    if (!this.refreshTimeout) {
      this.refreshTimeout = ONE_MINUTE_IN_MILLIS;
    }
  }

  public ngOnInit(): void {
    this.profileIntegrationService.shouldUpdate
      .pipe(
        startWith({}),
        takeUntil(this.destroyed),
        switchMap(() => this.profileIntegrationService.getIntegrationData()),
        tap(data => this.complete = !!data),
      )
      .subscribe();
  }

  public ngOnDestroy(): void {
    this.destroyed.next();
  }

  public goToIntegrationSettingsPage(): void {
    this.router.go('integration', { showSetupDialog: true }, { reload: true });
  }

  public async undoIntegrationSettings(): Promise<void> {
    await this.profileIntegrationService.setIntegrationData(null).toPromise();
  }

}
